var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContratorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.875C4.475 16.875 0 19.1125 0 21.875V24.375H20V21.875C20 19.1125 15.525 16.875 10 16.875ZM5 9.375C5 10.7011 5.52678 11.9729 6.46447 12.9105C7.40215 13.8482 8.67392 14.375 10 14.375C11.3261 14.375 12.5979 13.8482 13.5355 12.9105C14.4732 11.9729 15 10.7011 15 9.375M9.375 0.625C9 0.625 8.75 0.8875 8.75 1.25V5H7.5V1.875C7.5 1.875 4.6875 2.95 4.6875 6.5625C4.6875 6.5625 3.75 6.7375 3.75 8.125H16.25C16.1875 6.7375 15.3125 6.5625 15.3125 6.5625C15.3125 2.95 12.5 1.875 12.5 1.875V5H11.25V1.25C11.25 0.8875 11.0125 0.625 10.625 0.625H9.375Z",
    fill: "#10B48C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContratorIcon);
export default __webpack_public_path__ + "static/media/contratorIcon.3e90f8c52f2666d2267ab2e10123c878.svg";
export { ForwardRef as ReactComponent };